import { IonContent, IonHeader, IonPage, IonItem, IonAlert, IonButton, IonCard, IonCardContent } from '@ionic/react';
import React, { useState, useEffect, useContext } from 'react';
import ListItems from '../components/ListItems';
import InnerMenu from '../components/InnerMenu';
import {localStore} from '../App';
import PageEventHandler from "../components/PageEventHandler"
import './Islands.css';
import { BASE_URL } from '../utils/constant';
import { LanguageContext } from '../contexts/LanguageContext';
import { islandsTranslations } from '../translations/islands';
import NotificationRedirect from '../components/NotificationRedirect';

const Islands: React.FC = () => {
const [showAlert2, setShowAlert2] = useState(false);
const [islandsData, setIslandsData] = useState<[any] | null>(null);
const [loadingText, setLoadingText] = useState('Caricamento Aree naturalistiche e isole...');
const { language } = useContext(LanguageContext);
const t = islandsTranslations[language || 'it']; // Default to Italian if no language set
const pageName = t.pageTitle;

// fetch the list of docks from memory - if none fetch it from server - or return an empty array
async function fetchIslands()
{
  if (islandsData == null)
  {
    await localStore.get("islandsData")
      .then(
        (islands) =>
        {
          if (islands != null)
          {
            console.log('Informazioni sulle aree naturalistiche presenti in memoria.');
            setIslandsData(islands);
          }
          else
          {
              console.log('Non sono presenti informazioni sulle aree naturalistiche in memoria - scaricamento dal server');
              setLoadingText('Non sono presenti informazioni sulle aree naturalistiche in memoria - scaricamento dal server');
              fetchRemoteIslands().then(remoteIslands => {
                setIslandsData(remoteIslands);
              });
          }
        },
        (error) =>
        {
          console.log('Problema nella ricezione dei dati sulle aree naturalistiche: ',error);
        }
      );
    }
  }

  // fetch the list of docks from server
  async function fetchRemoteIslands():Promise<[any]|null>
  {
    return new Promise(function(resolve,reject)
    {
      // load docks from server
      const url = `${BASE_URL}/poServer.php?act=4&h=gkzLoFk0MN58TGqCJj`;
      fetch(url)
        .then(res => res.json())
        .then(
          (result) => {
            localStore.set('islandsData', result.content);
            resolve(result.content);
          },
          (error) => {
            console.log('Problema nella ricezione dei dati sulle aree naturalistiche: ',error);
            setLoadingText(t.loadingFromServer);
            setShowAlert2(true);
            resolve(null);
          }
      );
    });
  }


  useEffect(() => {
    fetchIslands();
  }, [islandsData]);

  return (
    <IonPage>
      <IonHeader>
        <InnerMenu name={pageName} />
      </IonHeader>
      <IonContent fullscreen>
        <IonItem lines="none">
          <h1 className="mainTit" slot="start" >{pageName}</h1>
        </IonItem>
        <IonCard color="light">
          <IonCardContent>{t.cardContent}</IonCardContent>
        </IonCard>
        <IonButton routerLink="/islandsMap" expand="block" fill="solid" className="ion-padding reg-islBtn ion-text-wrap" >
          {t.mapButtonText}
        </IonButton>

        {/* while loading */}
        {islandsData == null &&
          <div>{loadingText}</div>
        }
        {/* if loading went fine */}
        {/* these links are not needed anymore - but leaving the code here just in case
        {islandsData != null && islandsData.length > 0 &&
          <div className="ion-padding ion-text-center">
          {islandsData.map((element, index) => {
            return (
              <span key={index}>
                {element.province == null && // show only elements not in the array
                   <IonButton target="_blank" rel="noreferrer" href={element.url} expand="block" fill="solid" className="ion-padding reg-islBtn" size="large">
                    {element.region_name}<br />{element.title}
                   </IonButton>
                }
              </span>
            )
          })}
          </div>
        }
        */}
        {islandsData != null && islandsData.length > 0 &&
          <ListItems name={islandsTranslations.it.pageTitle} elements={islandsData} />
        }
      </IonContent>
      <IonAlert
        header={t.errorHeader}
        isOpen={showAlert2} message={t.errorAlert} buttons={[{ text: t.okButton }]} onDidDismiss={() => setShowAlert2(false)} />
        <PageEventHandler pageIndex={5} dockIndex={0}/>
        <NotificationRedirect /> {/* redirect to the page specified in the local storage */}
    </IonPage>
  );
};

export default Islands;
